import Swiper from 'swiper';

(function() {
  // Latest News Component
  const latestNewsSection = 'section.latests-news';
  if (document.querySelector(latestNewsSection)) {
    const latestNewsSwiper = new Swiper(latestNewsSection + ' .latest-news-swiper', {
      slidesPerView: 1,
      spaceBetween: 13,
      breakpoints: {
        992: {
          slidesPerView: 4,
          spaceBetween: 18,
        },
      },
    });
    jQuery('section.latests-news .slide-direction-left .go-prev').on('click', function (e) {
      e.preventDefault();
      latestNewsSwiper.slidePrev();
    });
    jQuery('section.latests-news .slide-direction-right .go-next').on('click', function (e) {
      e.preventDefault();
      latestNewsSwiper.slideNext();
    });
  }
})(jQuery, window, Swiper);
